module.exports = __webpack_public_path__ + "static/media/ribbon.29aedc78.svg";